import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#000'
    },
    secondary: {
      main: '#7f7f7f'
    },
    text: {
      primary: '#323232',
      secondary: '#7f7f7f'
    }
  },
  shadows,
  typography
});

export default theme;
